<template>
<div>
  <b-card class="text-center" title="Creacion de vehiculos">
  </b-card>
  <b-card class="text-left">
  <b-row>
    <b-col md="4">
          <label for="Placa">Placa </label>
          <b-form-input v-model="Placa"  type="text"  placeholder="Numero Placa."></b-form-input>
    </b-col>
    <b-col md="4">
          <label for="Marca">Marca </label>
          <b-form-input v-model="Marca"  type="text"  placeholder="Marca."></b-form-input>
    </b-col>
    <b-col md="4">
          <label for="Categoria">Categoria </label>
          <b-form-input v-model="Categoria"  type="text"  placeholder="Categoria."></b-form-input>
    </b-col>
    <b-col md="4">
          <label for="NombreRuta">Nombre Vehiculo</label>
          <b-form-input v-model="NombreRuta"  type="text"  placeholder="Nombre Vehiculo"></b-form-input>
    </b-col>
    <b-col md="4">
          <label for="Sillas"># Sillas </label>
          <input v-model="Sillas" type="text" class="form-control" @keypress="onlyNumbers" placeholder="Numero Sillas.">
    </b-col>
    <b-col md="12">
      <br>
        <label for="Observaciones">Observaciones</label>  
        <b-form-textarea id="textarea1" placeholder="" :rows="3" :max-rows="6" v-model="obj">
        </b-form-textarea>
    </b-col>
    <b-col md="3">
        <br>
        <b-button variant="success" @click="enviar" >Actualizar</b-button>
    </b-col>
  </b-row>
  </b-card>

</div>
</template>
<script>
export default {
 name: 'vehiculos', 
 data (){
        return{
        Placa:'',
        Marca:'',
        Categoria:'',
        NombreRuta:'',
        Sillas:'',
        obj:'',
        }
 },
 created: function(){
    this.consultar()
 },
    methods:{
        onlyNumbers(event) {
            let key = window.event ? event.which : event.keyCode
            if ((key < 48 || key > 57) && key != 8)
                event.preventDefault()
        },
        consultar(){
          let data = {id: this.$route.params.id};
          this.$store.dispatch('schoolroutesbuscarVehiculos', data).then(Response=>{      
                this.Placa = this.$store.getters.schoolroutesVehicles.placa
                this.Marca = this.$store.getters.schoolroutesVehicles.marca
                this.Categoria = this.$store.getters.schoolroutesVehicles.categoria
                this.NombreRuta = this.$store.getters.schoolroutesVehicles.nombre_ruta
                this.Sillas = this.$store.getters.schoolroutesVehicles.sillas
                this.obj = this.$store.getters.schoolroutesVehicles.observaciones
                }) 

        },
        enviar(){
            if(this.Placa !='' && this.NombreRuta !='' && this.Sillas !='' && this.Marca !='' && this.Categoria !='' && this.obj !=''){
                    let  array={id: this.$route.params.id,'placa':this.Placa,'nombre_ruta':this.NombreRuta,'sillas':this.Sillas,'marca':this.Marca,'categoria':this.Categoria,'observaciones':this.obj}
                    this.$store.dispatch('schoolroutesactualizaVehiculos', array).then(Response=>{ 
                    this.varimgtext='<div style="text-align: center;"><h1>Vehiculo Actualizado</h1></span></div>'  
                    this.$root.showInfoDialog('alerta', this.varimgtext, 'Aceptar')     
                    this.$router.push("/schoolroutes/vehicles/list");             
                }) 
            }else{
                alert('Tienes Campos Vacios');
            }
             

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/schoolroutes/vehicles/edit.vue